class Permissions {
    
    /**
     * Checks if the user have authorization to this feature or button
     * Returns true or false
     * @param  {string} user - The name of the user
     * @param  {string} feature - The feature this user is trying to use
     */
    static checkPermission = async(user,feature)=>{
        
        let requestResult;
        let permissionResult;

        var formdata = new FormData();
        formdata.append("user", user);
        formdata.append("feature", feature);

        var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
        };

        await fetch("https://dashboard.realsexdoll.info/php/permissions/checkpermission.php", requestOptions)
        .then(response => response.text())
        .then(result => requestResult = result)
        .catch(error => console.log('error', error));

        if(requestResult == "1"){
            console.log(feature+" authorized")
            permissionResult = true;
        }else{
            console.log(feature+" permission denied")
            permissionResult = false;
        }

        return permissionResult;
          
    }

    /**
     * 
     * Returns an array of all the permissions available
     * @return {Array}
     * 
     */
    static getAllPermissions = async()=>{

        let requestResult;

        await fetch("https://dashboard.realsexdoll.info/php/permissions/permissions.php")
        .then(response => response.json())
        .then(result => requestResult = result)
        .catch(error => console.log('error', error));

        return requestResult;

    }
    /**
     * Return an array with the employees that are inside an array of groups with no repetitions
     * @param  {} groups - a string with the groups needed example "HR,Admin,QC"
     * 
     */
    static getPermissionGroups = async(groups)=>{

        let groupsResult;

            var formdata = new FormData();
            formdata.append("groups",groups);
    
            var requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow'
            };
    
            let groupsRequest = await fetch("https://dashboard.realsexdoll.info/php/permissions/getgroup.php", requestOptions)
            groupsResult = await groupsRequest.json();
            
            
        return groupsResult;
        
    }

    

       

  
       

}
  
export default Permissions;